var translations = {
    de: {
        content: 'Die Kreditanfrage ist bereits abgeschlossen. Änderungen oder Ergänzungen können Sie in Form einer neuen Anfrage erzeugen. Dazu werden Sie nun weitergeleitet',
        buttonTitle: 'Weiterleiten',
    },
};
export default translations;
